/* ═══════════════════════════════════════════════════════════
   pf-unified-cards.js  v2
   Enhances collection & search product cards:
   - Adds colored stock-status dots
   - Manages sticky sidebar offset
   (View toggle handled by theme's existing buttons)
   ═══════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var page = document.querySelector('.template-collection') || document.querySelector('.template-search');
  if (!page) return;

  /* ══════════════════════════════════════
     1. STOCK STATUS DOTS
     ══════════════════════════════════════ */

  function enhanceStockStatus(scope) {
    var root = scope || page;
    root.querySelectorAll('.stock_status_wrap').forEach(function (wrap) {
      if (wrap.dataset.pfuEnhanced) return;
      wrap.dataset.pfuEnhanced = '1';

      var text = wrap.textContent.trim().toLowerCase();
      var status = '';
      if (text.indexOf('på lager') !== -1 || text.indexOf('in stock') !== -1) {
        status = 'in';
      } else if (text.indexOf('forventet') !== -1 || text.indexOf('expected') !== -1 || text.indexOf('dager') !== -1) {
        status = 'expected';
      } else if (text.indexOf('ikke') !== -1 || text.indexOf('out') !== -1 || text.indexOf('utsolgt') !== -1) {
        status = 'out';
      }

      if (status) wrap.classList.add('stock_status_wrap--' + status);

      var icon = wrap.querySelector('.badge-stock-icon');
      if (icon) icon.classList.add('pfu-stock-dot');
    });

    root.querySelectorAll('.badge-stock').forEach(function (wrap) {
      if (wrap.dataset.pfuEnhanced) return;
      wrap.dataset.pfuEnhanced = '1';
      var icon = wrap.querySelector('.badge-stock-icon');
      if (icon) icon.classList.add('pfu-stock-dot');
    });
  }

  /* ══════════════════════════════════════
     2. STICKY SIDEBAR OFFSET
     ══════════════════════════════════════ */

  function updateSidebarTop() {
    var header = document.querySelector('header, .header, .shopify-section-header, #shopify-section-header');
    if (!header) return;
    var h = header.getBoundingClientRect().height;
    document.documentElement.style.setProperty('--pf-sidebar-top', (h + 20) + 'px');
  }

  /* ══════════════════════════════════════
     3. MUTATION OBSERVER
     ══════════════════════════════════════ */

  function observeProductGrid() {
    var grid = page.querySelector('#product-grid');
    if (!grid) return;

    var observer = new MutationObserver(function () {
      enhanceStockStatus(grid);
    });
    observer.observe(grid, { childList: true, subtree: true });
  }

  /* ══════════════════════════════════════
     4. MOBILE FILTER DRAWER OPEN/CLOSE
     (Collection & Search page)
     ══════════════════════════════════════ */

  function bindFilterDrawer() {
    var sidebar = page.querySelector('.filters_side_bar_custom');
    if (!sidebar) return;

    function openDrawer() {
      sidebar.classList.add('opened');
      document.body.classList.add('page-layout-sidebar-drawer-open');
      document.body.classList.add('overflow-hidden-tablet');
    }

    function closeDrawer() {
      sidebar.classList.remove('opened');
      document.body.classList.remove('page-layout-sidebar-drawer-open');
      document.body.classList.remove('overflow-hidden-tablet');
    }

    /* Delegated click handler */
    document.addEventListener('click', function (event) {
      var target = event.target;

      /* OPEN: filter-button */
      var openBtn = target.closest('.button-sidebar-drawer-open');
      if (openBtn) {
        event.preventDefault();
        openDrawer();
        return;
      }

      /* CLOSE: X, Søk, eller hvilken som helst dismiss-knapp */
      var dismissBtn = target.closest('.js-button-sidebar-drawer-dismiss');
      if (dismissBtn) {
        closeDrawer();
        return;
      }

      /* CLOSE: klikk utenfor drawer (på overlay) */
      if (sidebar.classList.contains('opened') &&
          !target.closest('.filters_side_bar_custom') &&
          !target.closest('.button-sidebar-drawer-open')) {
        closeDrawer();
      }
    });

    /* CLOSE: ESC-tast */
    document.addEventListener('keyup', function (event) {
      if ((event.key === 'Escape' || event.code === 'Escape') &&
          sidebar.classList.contains('opened')) {
        closeDrawer();
      }
    });
  }

  /* ══════════════════════════════════════
     INIT
     ══════════════════════════════════════ */

  function init() {
    enhanceStockStatus();
    updateSidebarTop();
    observeProductGrid();
    bindFilterDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('resize', updateSidebarTop, { passive: true });
  window.addEventListener('scroll', function () {
    requestAnimationFrame(updateSidebarTop);
  }, { passive: true, once: true });

})();

/* ═══════════════════════════════════════════════════════════
   SB RABATTMERKER (29.10)
   Rabatt under 15 % og minst 100 kr: "SPAR X kr" (svart + gul)
   i stedet for rødt "-X% Salg". Felles stil for begge,
   størrelse M (14 px PC, 12 px mobil).
   Gjelder kort som filter.js tegner i #product-grid, og
   søkeforslagene i toppmenyen (header-filter.js).
   Liquid-kortene har samme regel i card-product.liquid og stilen
   i snippets/sb-rabattmerker-css.liquid. Endres stilen, endre begge.

   SB MOBILKORT K1 (30.10)
   Strammere produktkort på mobil (kolleksjon og søk): mindre luft
   over og under teksten, prisen venstrejustert og "inkl. mva" på
   samme linje som prisen.
   ═══════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var SB_MAX_PCT = 15;  // rabatt i prosent: under dette vises kronebeløp
  var SB_MIN_KR = 100;  // sparebeløp under dette beholder prosentmerket

  var T = '.card-product .card-media .sale_tag_card_per.absolute_card-tag_media';
  var S = '.predictive-search-item-content .sale_tag_card_per.sb-spar-tag,.sale_badge_mobile .sale_tage.sb-spar-tag';

  // K1: velger for kort på kolleksjons- og søkesiden
  function k1(sel) {
    return 'html body.template-collection #product-grid .card-product ' + sel +
      ',html body.template-search #product-grid .card-product ' + sel;
  }

  var CSS = '' +
    T + '{position:absolute;top:10px;left:10px;right:auto;bottom:auto;margin:0;width:auto;max-width:none;min-width:0;' +
      'background:#E00000;color:#fff;font-family:inherit;font-size:14px!important;font-weight:800;line-height:1;' +
      'letter-spacing:.01em;text-transform:none;padding:6px 10px!important;border-radius:4px;z-index:2}' +
    T + '.sb-spar-tag{display:inline-flex;align-items:stretch;padding:0!important;background:transparent!important;' +
      'color:#111;overflow:hidden;letter-spacing:.02em}' +
    '.sb-spar-tag .sb-spar-l{background:#111;color:#fff;padding:6px 9px}' +
    '.sb-spar-tag .sb-spar-v{background:#FFD60A;color:#111;padding:6px 10px;white-space:nowrap}' +
    '.list-view ' + T + '.sb-spar-tag{display:none}' +
    S + '{display:inline-flex!important;align-items:stretch;padding:0!important;background:transparent!important;' +
      'color:#111!important;border-radius:3px!important;overflow:hidden;line-height:1!important;font-weight:800!important}' +
    '.predictive-search-item-content .sb-spar-tag .sb-spar-l,.sale_badge_mobile .sb-spar-tag .sb-spar-l{padding:3px 5px}' +
    '.predictive-search-item-content .sb-spar-tag .sb-spar-v,.sale_badge_mobile .sb-spar-tag .sb-spar-v{padding:3px 6px}' +
    '@media (max-width:749px){' +
      T + '{top:7px;left:7px;font-size:12px!important;padding:4px 7px!important;border-radius:3px}' +
      T + '.sb-spar-tag{padding:0!important}' +
      '.sb-spar-tag .sb-spar-l{padding:4px 6px}' +
      '.sb-spar-tag .sb-spar-v{padding:4px 7px}' +
      '.predictive-search-item-content .sb-spar-tag .sb-spar-l,.sale_badge_mobile .sb-spar-tag .sb-spar-l{padding:3px 5px}' +
      '.predictive-search-item-content .sb-spar-tag .sb-spar-v,.sale_badge_mobile .sb-spar-tag .sb-spar-v{padding:3px 6px}' +
      /* K1 mobilkort */
      k1('.card-info') + '{padding-top:3px!important;padding-bottom:2px!important}' +
      k1('.card-footer') + '{padding-top:6px!important}' +
      k1('.price') + '{align-self:flex-start!important;margin-left:0!important;margin-right:auto!important;text-align:left!important}' +
      k1('.price-container') + '{align-items:flex-start!important;margin:0!important}' +
      k1('.price-item-sale') + ',' + k1('.price-regular .price-item-regular') +
        '{display:flex!important;align-items:baseline!important;gap:4px!important;font-size:16px!important;font-weight:800!important;line-height:1.25!important}' +
      k1('.price-item-sale .sup') + ',' + k1('.price-regular .price-item-regular .sup') +
        '{display:inline!important;margin:0!important;font-size:9px!important;font-weight:400!important}' +
      k1('.price-discount .price-item-regular') + '{font-size:12px!important;line-height:1.3!important}' +
    '}';

  function addCss() {
    if (document.getElementById('sb-spar-tag-css')) return;
    var s = document.createElement('style');
    s.id = 'sb-spar-tag-css';
    s.textContent = CSS;
    (document.head || document.documentElement).appendChild(s);
  }

  // filter.js skriver priser som "6.475,00 kr"
  function parseKr(text) {
    var m = String(text || '').match(/\d[\d.]*,\d{2}/);
    if (!m) return NaN;
    return parseFloat(m[0].replace(/\./g, '').replace(',', '.'));
  }

  function fmt(n) {
    return Math.round(n).toLocaleString('nb-NO');
  }

  function sparHtml(kr) {
    return '<span class="sb-spar-l">SPAR</span><span class="sb-spar-v">' + kr + ' kr</span>';
  }

  function convert(scope) {
    var tags = scope.querySelectorAll('.sale_tag_card_per.absolute_card-tag_media:not(.sb-spar-tag):not([data-sb-checked])');
    tags.forEach(function (tag) {
      tag.setAttribute('data-sb-checked', '1');
      var card = tag.closest('.card-product');
      if (!card) return;
      var reg = card.querySelector('.price-sale .price-item-regular');
      var sale = card.querySelector('.price-sale .price-item-sale');
      if (!reg || !sale) return;
      var cmp = parseKr(reg.textContent);
      var price = parseKr(sale.textContent);
      if (!(price > 0) || !(cmp > price)) return;
      var save = cmp - price;
      var pct = save * 100 / cmp;
      if (pct >= SB_MAX_PCT || save < SB_MIN_KR) return;
      var kr = fmt(save);
      tag.classList.add('sb-spar-tag');
      tag.setAttribute('aria-label', 'Spar ' + kr + ' kr');
      tag.innerHTML = sparHtml(kr);
    });
  }

  /* ── Søkeforslag i toppmenyen (header-filter.js) ──
     Prisene kommer som "4690.00kr". Vi formaterer dem som resten
     av butikken ("4.690,00 kr"), runder prosenten riktig og bruker
     SPAR-merket under 15 %. */

  function rawNum(el) {
    if (!el) return NaN;
    var m = el.textContent.match(/\d+(?:\.\d+)?/);
    return m ? parseFloat(m[0]) : NaN;
  }

  function moneyText(n) {
    return n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' kr';
  }

  function setFirstText(el, text) {
    if (!el) return;
    for (var i = 0; i < el.childNodes.length; i++) {
      var node = el.childNodes[i];
      if (node.nodeType === 3 && /\d/.test(node.nodeValue)) {
        node.nodeValue = ' ' + text + ' ';
        return;
      }
    }
  }

  function fixSearch(scope) {
    var items = scope.querySelectorAll('.predictive-search-list-item-product:not([data-sb-checked])');
    items.forEach(function (li) {
      li.setAttribute('data-sb-checked', '1');
      var regEl = li.querySelector('.price-regular .price-item-regular');
      var cmpEl = li.querySelector('.price-item-compare');
      var price = rawNum(regEl);
      var cmp = rawNum(cmpEl);
      if (price > 0) setFirstText(regEl, moneyText(price));
      if (cmp > 0) setFirstText(cmpEl, moneyText(cmp));
      if (!(price > 0) || !(cmp > price)) return;
      var save = cmp - price;
      var pct = save * 100 / cmp;
      var useSpar = pct < SB_MAX_PCT && save >= SB_MIN_KR;
      li.querySelectorAll('.sale_tag_card_per, .sale_tage').forEach(function (tag) {
        if (useSpar) {
          var kr = fmt(save);
          tag.classList.add('sb-spar-tag');
          tag.setAttribute('aria-label', 'Spar ' + kr + ' kr');
          tag.innerHTML = sparHtml(kr);
        } else {
          tag.textContent = '-' + Math.round(pct) + '%' + (tag.classList.contains('sale_tage') ? '' : ' Salg');
        }
      });
    });
  }

  function init() {
    addCss();
    var grid = document.querySelector('#product-grid');
    if (grid) {
      convert(grid);
      new MutationObserver(function () { convert(grid); })
        .observe(grid, { childList: true, subtree: true });
    }
    document.querySelectorAll('.predictive-search').forEach(function (box) {
      fixSearch(box);
      new MutationObserver(function () { fixSearch(box); })
        .observe(box, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();